var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-09-21
 * @brief SIE 솔루션 그룹 관리 개발
 *
 ********************************************************************/
import { useEffect, useRef, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reLoadPage, reLoadState, userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useAsync } from "react-async";
import { alertState } from "../../../recoil/assessmentState";
import { loadingBoxState } from "../../../recoil/menuState";
export default function SolutionGroups(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    // props
    const { handleOpenPop } = props;
    // state
    const [errorList, setErrorList] = useState([]);
    const [bigGroupList, setBigGroupList] = useState([]);
    const [bigGroup, setBigGroup] = useState(null);
    const [bigGroupEdit, setBigGroupEdit] = useState(null);
    const [middleGroup, setMiddleGroup] = useState(null);
    const [middleGroupEdit, setMiddleGroupEdit] = useState(null);
    const [smallGroup, setSmallGroup] = useState(null);
    const [smallGroupEdit, setSmallGroupEdit] = useState(null);
    const [popreset, setPopreset] = useState(false);
    const [isEnglish, setIsEnglish] = useState(false);
    useEffect(() => {
        // 대그룹 등록
        handleOpenPop("pop-a-1", _jsx(BigGroupAddPop, { setPopreset: setPopreset, bigGroupEdit: bigGroupEdit, setBigGroupEdit: setBigGroupEdit, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uB300\uADF8\uB8F9 \uB4F1\uB85D" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-a-1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 대그룹 수정
        handleOpenPop("pop-e-1", _jsx(BigGroupEditPop, { bigGroupEdit: bigGroupEdit, setPopreset: setPopreset, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uB300\uADF8\uB8F9 \uC218\uC815" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-e-1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 대그룹 삭제
        handleOpenPop("pop-d-1", _jsx(BigGroupDeletePop, { bigGroup: bigGroup, setBigGroup: setBigGroup, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uB300\uADF8\uB8F9 \uC0AD\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-d-1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 중그룹 등록
        handleOpenPop("pop-a-2", _jsx(MiddleGroupAddPop, { bigGroup: bigGroup, setPopreset: setPopreset, middleGroupEdit: middleGroupEdit, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [bigGroup && _jsxs("h1", { children: [bigGroup.name, " \uC911\uADF8\uB8F9 \uB4F1\uB85D"] }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-a-2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 중그룹 수정
        handleOpenPop("pop-e-2", _jsx(MiddleGroupEditPop, { middleGroupEdit: middleGroupEdit, setPopreset: setPopreset, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [bigGroup && _jsxs("h1", { children: [bigGroup.name, " \uC911\uADF8\uB8F9 \uC218\uC815"] }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-e-2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 중그룹 삭제
        handleOpenPop("pop-d-2", _jsx(MiddleGroupDeletePop, { middleGroup: middleGroup, setMiddleGroup: setMiddleGroup, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uC194\uB8E8\uC158 \uC911\uADF8\uB8F9 \uC0AD\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-d-2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 소그룹 등록
        handleOpenPop("pop-a-3", _jsx(SmallGroupAddPop, { middleGroup: middleGroup, smallGroupEdit: smallGroupEdit, setPopreset: setPopreset, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [middleGroup && _jsxs("h1", { children: [middleGroup.name, " \uC18C\uADF8\uB8F9 \uB4F1\uB85D"] }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-a-3") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 소그룹 수정
        handleOpenPop("pop-e-3", _jsx(SmallGroupEditPop, { smallGroupEdit: smallGroupEdit, setPopreset: setPopreset, isEnglish: isEnglish, setIsEnglish: setIsEnglish, htmlClose: _jsxs(_Fragment, { children: [middleGroup && _jsxs("h1", { children: [middleGroup.name, " \uC18C\uADF8\uB8F9 \uC218\uC815"] }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-e-3") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 소그룹 삭제
        handleOpenPop("pop-d-3", _jsx(SmallGroupDeletePop, { smallGroupEdit: smallGroupEdit, setSmallGroupEdit: setSmallGroupEdit, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: "\uC18C\uADF8\uB8F9 \uC0AD\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-d-3") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [smallGroupEdit, middleGroup, middleGroupEdit, bigGroup, bigGroupEdit, isEnglish]);
    // 대그룹 목록 조회
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/biggroups`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setBigGroupList(data.body);
                setBigGroupEdit(data.body[0]);
            }
            else {
                setErrorList(data.errorList);
            }
        }
    }, [data, reload]);
    function ClickMiddleGroupList(data) {
        setBigGroup(data);
        setMiddleGroup(null);
        setSmallGroup(null);
    }
    function BigSolution(e, type, item) {
        CUTIL.jsopen_Popup(e);
        setIsEnglish(type);
        if (type == true) {
            setBigGroupEdit(item);
        }
    }
    function DeliveryDataPop(e, item, type) {
        setIsEnglish(type);
        setBigGroupEdit(item);
        CUTIL.jsopen_Popup(e);
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uC194\uB8E8\uC158 \uADF8\uB8F9 \uAD00\uB9AC" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("strong", Object.assign({ className: "font-15" }, { children: "\uB300\uADF8\uB8F9" })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-a-1", onClick: (e) => BigSolution(e, false, null) }, { children: _jsx("span", { children: "\uC2E0\uADDC \uADF8\uB8F9 \uCD94\uAC00" }) })) }))] })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uB300\uADF8\uB8F9,\uB0B4\uC6A9,\uC218\uC815,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uB300\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uB300\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "29%" } }), _jsx("col", { style: { width: "45%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "5%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB300\uADF8\uB8F9" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB0B4\uC6A9" })), _jsx("th", Object.assign({ scope: "col", className: "sort desc" }, { children: _jsx("span", Object.assign({ className: "center" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC218\uC815" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC0AD\uC81C" }))] }) }), _jsx("tbody", { children: bigGroupList &&
                                            bigGroupList.map((list, idx) => (_jsxs("tr", Object.assign({ className: bigGroup && bigGroup.id == list.id ? "selected" : "", onClick: (e) => ClickMiddleGroupList(list) }, { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: list.name }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w100p" }, { children: list && list.description ? list.description : "-" })) }), !list.isEnglish ? (_jsx("td", { children: _jsxs("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-a-1", onClick: (e) => BigSolution(e, true, list) }, { children: [_jsx("span", Object.assign({ className: "hoverno-txt" }, { children: "\uB0B4\uC6A9\uC5C6\uC74C" })), _jsx("span", Object.assign({ className: "hover-txt" }, { children: "\uC124\uC815" }))] })) })) : (_jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-e-1", onClick: (e) => DeliveryDataPop(e, list, true) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-e-1" }, { children: "\uC218\uC815" })) })) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-e-1", onClick: (e) => DeliveryDataPop(e, list, false) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-d-1", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), "bigGroupList" + idx.toString()))) })] })) })), bigGroup && bigGroup.id > 0 && (_jsx(MiddleGroupRequest, { bigGroup: bigGroup, middleGroup: middleGroup, setMiddleGroup: setMiddleGroup, middleGroupEdit: middleGroupEdit, setMiddleGroupEdit: setMiddleGroupEdit, setSmallGroup: setSmallGroup, setIsEnglish: setIsEnglish })), middleGroup && middleGroup.id > 0 && (_jsx(SmallGroupRequest, { middleGroup: middleGroup, smallGroup: smallGroup, setSmallGroup: setSmallGroup, smallGroupEdit: smallGroupEdit, setSmallGroupEdit: setSmallGroupEdit, setIsEnglish: setIsEnglish }))] }))] })) }));
}
function MiddleGroupRequest(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const reloadState = useRecoilValue(reLoadState);
    // props
    const { bigGroup, middleGroup, setMiddleGroup, setMiddleGroupEdit, setSmallGroup, setErrorList, setIsEnglish } = props;
    // state
    const [middleGroupList, setMiddleGroupList] = useState([]);
    let appPath = `bigGroupId=${bigGroup.id}`;
    // 중그룹 목록
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/middlegroups?${appPath}`,
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadState,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setMiddleGroupList(data.body);
            }
            else {
                setErrorList(data.errorList);
            }
        }
    }, [data, reloadState]);
    function ClickSmallGroupList(data) {
        setMiddleGroup(data);
        setSmallGroup(null);
    }
    function MiddleSolution(e, type, item) {
        CUTIL.jsopen_Popup(e);
        setIsEnglish(type);
        if (type == true) {
            setMiddleGroupEdit(item);
        }
    }
    function DeliveryDataPop(e, item, type) {
        return __awaiter(this, void 0, void 0, function* () {
            setMiddleGroupEdit(item);
            CUTIL.jsopen_Popup(e);
            setIsEnglish(type);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "brd-top-1 mt-40 mb-34" }), _jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("strong", Object.assign({ className: "font-15" }, { children: "\uC911\uADF8\uB8F9" })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-a-2", onClick: (e) => MiddleSolution(e, false, null) }, { children: _jsx("span", { children: "\uC2E0\uADDC \uADF8\uB8F9 \uCD94\uAC00" }) })) })) }))] })), middleGroupList.length > 0 && (_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uB300\uADF8\uB8F9,\uB0B4\uC6A9,\uC218\uC815,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC911\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC911\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "35%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "5%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB300\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC911\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB0B4\uC6A9" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB300\uD45C \uC774\uBBF8\uC9C0" })), _jsx("th", Object.assign({ scope: "col", className: "sort desc" }, { children: _jsx("span", Object.assign({ className: "center" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC218\uC815" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC0AD\uC81C" }))] }) }), _jsx("tbody", { children: middleGroupList.map((list, idx) => (_jsxs("tr", Object.assign({ className: middleGroup && middleGroup.id == list.id ? "selected" : "", onClick: (e) => ClickSmallGroupList(list) }, { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: bigGroup.name }), _jsx("td", { children: list.name }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w100p" }, { children: list && list.description ? list.description : "-" })) }), _jsx("td", { children: _jsx("ul", Object.assign({ className: "filelist m-0" }, { children: _jsx("li", { children: _jsx("span", Object.assign({ className: "font-14" }, { children: list && list.image ? list.image.name : "-" })) }) })) }), !list.isEnglish ? (_jsx("td", { children: _jsxs("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-a-2", onClick: (e) => MiddleSolution(e, true, list) }, { children: [_jsx("span", Object.assign({ className: "hoverno-txt" }, { children: "\uB0B4\uC6A9\uC5C6\uC74C" })), _jsx("span", Object.assign({ className: "hover-txt" }, { children: "\uC124\uC815" }))] })) })) : (_jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-e-2", onClick: (e) => DeliveryDataPop(e, list, true) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-e-1" }, { children: "\uC218\uC815" })) })) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-e-2", onClick: (e) => DeliveryDataPop(e, list, false) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-d-2", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), "middleGroupList" + idx.toString()))) })] })) })))] }));
}
function SmallGroupRequest(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const reLoadPages = useRecoilValue(reLoadPage);
    const [smallGroupList, setSmallGroupList] = useState([]);
    // props
    const { middleGroup, smallGroup, setSmallGroup, setSmallGroupEdit, setErrorList, setPopreset, setIsEnglish } = props;
    // state
    let appPath = `middleGroupId=${middleGroup.id}`;
    // 소그룹 목록
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/smallgroups?${appPath}`,
        userToken: userInfo.loginInfo.token,
        watch: appPath + reLoadPages,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSmallGroupList(data.body);
            }
            else {
                setErrorList(data.errorList);
            }
        }
    }, [data, reLoadPages]);
    function ClickSmallGroupList(data) {
        setSmallGroup(data);
    }
    function SmallSolution(e, type, item) {
        CUTIL.jsopen_Popup(e);
        setIsEnglish(type);
        if (type == true) {
            setSmallGroupEdit(item);
        }
    }
    function DeliveryDataPop(e, item, type) {
        setSmallGroupEdit(item);
        CUTIL.jsopen_Popup(e);
        setIsEnglish(type);
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "brd-top-1 mt-40 mb-34" }), _jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("strong", Object.assign({ className: "font-15" }, { children: "\uC18C\uADF8\uB8F9" })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-a-3", onClick: (e) => SmallSolution(e, false, null) }, { children: _jsx("span", { children: "\uC2E0\uADDC \uADF8\uB8F9 \uCD94\uAC00" }) })) }))] })), smallGroupList.length > 0 && (_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uB300\uADF8\uB8F9,\uB0B4\uC6A9,\uC218\uC815,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC18C\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC18C\uADF8\uB8F9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "18%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "34%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "5%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC911\uADF8\uB8F9" })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC18C\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB0B4\uC6A9" })), _jsx("th", Object.assign({ scope: "col", className: "sort desc" }, { children: _jsx("span", Object.assign({ className: "center" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC218\uC815" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC0AD\uC81C" }))] }) }), _jsx("tbody", { children: smallGroupList.map((list, idx) => (_jsxs("tr", Object.assign({ className: smallGroup && smallGroup.id == list.id ? "selected" : "", onClick: (e) => ClickSmallGroupList(list) }, { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: middleGroup.name }), _jsx("td", { children: list.name }), _jsx("td", { children: _jsx("p", Object.assign({ className: "esllipsis w100p" }, { children: list.description })) }), !list.isEnglish ? (_jsx("td", { children: _jsxs("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-a-3", onClick: (e) => SmallSolution(e, true, list) }, { children: [_jsx("span", Object.assign({ className: "hoverno-txt" }, { children: "\uB0B4\uC6A9\uC5C6\uC74C" })), _jsx("span", Object.assign({ className: "hover-txt" }, { children: "\uC124\uC815" }))] })) })) : (_jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-e-3", onClick: (e) => DeliveryDataPop(e, list, true) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-e-1" }, { children: "\uC218\uC815" })) })) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-e-3", onClick: (e) => DeliveryDataPop(e, list, false) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-d-3", onClick: (e) => DeliveryDataPop(e, list, false) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), "smallGroupList" + idx.toString()))) })] })) })))] }));
}
function BigGroupAddPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setreLoad = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { setPopreset, isEnglish, setIsEnglish, bigGroupEdit, setBigGroupEdit } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    function BigGropAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setName(null);
            setDescription(null);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyconsulting/biggroup`,
                appQuery: {
                    name: name,
                    description: description,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setreLoad(true);
                    // setBigGroup(data.body);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 대그룹이 등록되었습니다." }));
                    ClosePop("pop-a-1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setreLoad(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function BigGropIsEnglish(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setName(null);
            setDescription(null);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/biggroup/${bigGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setreLoad(true);
                    // setBigGroup(data.body);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 영문대그룹이 등록되었습니다." }));
                    ClosePop("pop-a-1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setreLoad(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(null);
        setDescription(null);
        setPopreset(true);
        // 다국어
        setIsEnglish(false);
        setBigGroupEdit(null);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-a-1") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), isEnglish ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => BigGropIsEnglish(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => BigGropAdd(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) })))] }))] }));
}
function BigGroupEditPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setreLoad = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { bigGroupEdit, setPopreset, isEnglish, setIsEnglish } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (bigGroupEdit) {
            DeliveryDataPopitem(bigGroupEdit.id, isEnglish);
        }
    }, [bigGroupEdit && bigGroupEdit.id, isEnglish]);
    function DeliveryDataPopitem(id, isEnglish) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/biggroup/${id}`,
                appQuery: {
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setName(data.body.name);
                    setDescription(data.body.description);
                }
            }
        });
    }
    function BigGropEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/biggroup/${bigGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setreLoad(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: `대그룹 ${!isEnglish ? "" : "영문"}솔루션이 수정 되었습니다` }));
                    ClosePop("pop-e-1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setreLoad(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(bigGroupEdit.name);
        setDescription(bigGroupEdit.description);
        setPopreset(true);
        setIsEnglish(false);
        // setBigGroupEdit(null)
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: bigGroupEdit ? "" : "텍스트를 입력하세요", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: bigGroupEdit ? "" : "텍스트를 입력하세요", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-e-1") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => BigGropEdit(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function BigGroupDeletePop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setreLoad = useSetRecoilState(reLoad);
    const setReloadState = useSetRecoilState(reLoadState);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { bigGroup, setBigGroup } = props;
    // state
    const [errorList, setErrorList] = useState([]);
    function BigGroupDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/energyconsulting/biggroup/${bigGroup.id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: bigGroup,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setreLoad(true);
                    setReloadState(true);
                    setReloadPage(true);
                    setBigGroup(null);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "대그룹이 삭제 되었습니다." }));
                    CUTIL.jsclose_Popup("pop-d-1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                    setReloadState(false);
                    setreLoad(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 카드에 등록되어 있는 그룹입니다." }));
                    CUTIL.jsclose_Popup("pop-d-1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC194\uB8E8\uC158\uC758 \uB300\uADF8\uB8F9\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-d-1") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            BigGroupDelete(e);
                        } }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
function MiddleGroupAddPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadState = useSetRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { bigGroup, setPopreset, isEnglish, setIsEnglish, middleGroupEdit } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [defaultImg, setDefaultImg] = useState(null);
    const [file, setFile] = useState([]);
    const fileRef = useRef();
    function MiddleGropAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyconsulting/middlegroup?bigGroupId=${bigGroup.id}`,
                appQuery: {
                    name: name,
                    description: description,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!defaultImg) {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 중그룹이 등록되었습니다." }));
                        ClosePop("pop-a-2");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setRecoilIsLoadingBox(false);
                        setReloadState(false);
                    }
                    else {
                        DefaultImages(data.body.id);
                    }
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-a-2");
                }
            }
        });
    }
    function MiddleGropEnglish(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/middlegroup/${middleGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (defaultImg) {
                        DefaultImages(data.body.id);
                    }
                    else {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 영문중그룹이 등록되었습니다." }));
                        ClosePop("pop-a-2");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                    }
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    // 대표 이미지
    function DefaultImages(middleGroupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", defaultImg);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/image/energyconsulting/middlegroup?middleGroupId=${middleGroupId}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        DefaultImages(data.body.id);
                    }
                    else {
                        setErrorList(data.errorList);
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-a-2");
                    }
                }
            }
        });
    }
    // 첨부파일
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function DefaultFileImage(e) {
        const file = e.target.files[0];
        setDefaultImg(file);
        e.target.value = "";
    }
    // 이미지 삭제
    function DeleteFile(e) {
        setDefaultImg(null);
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(null);
        setDescription(null);
        setDefaultImg(null);
        setFile([]);
        setErrorList([]);
        setPopreset(true);
        setIsEnglish(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB300\uD45C \uC774\uBBF8\uC9C0" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uD074\uB9AD\uD558\uC5EC \uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ onClick: (e) => handleFileUpload(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file3", ref: fileRef, accept: "image/*", onChange: (e) => DefaultFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "500MB\uC774\uD558\uC758 JPG, PNG\uD30C\uC77C 1\uAC1C\uB9CC \uC5C5\uB85C\uB4DC \uAC00\uB2A5\uD569\uB2C8\uB2E4." })), _jsx("ul", Object.assign({ className: "filelist" }, { children: defaultImg && (_jsxs("li", { children: [_jsx("span", { children: defaultImg.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => DeleteFile(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) }))] }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-a-2") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), isEnglish ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => MiddleGropEnglish(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => MiddleGropAdd(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) })))] }))] }));
}
function MiddleGroupEditPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadState = useSetRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { middleGroupEdit, setPopreset, isEnglish, setIsEnglish } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [defaultImg, setDefaultImg] = useState(null);
    const [file, setFile] = useState([]);
    const fileRef = useRef();
    useEffect(() => {
        if (middleGroupEdit) {
            DeliveryDataPopitem(middleGroupEdit.id, isEnglish);
        }
    }, [middleGroupEdit && middleGroupEdit.id, isEnglish]);
    function DeliveryDataPopitem(id, isEnglish) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/middlegroup/${id}`,
                appQuery: {
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setName(data.body.name);
                    setDescription(data.body.description);
                    setDefaultImg(data.body.image);
                }
            }
        });
    }
    function MiddleGropEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/middlegroup/${middleGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (defaultImg) {
                        DefaultImages(data.body.id);
                    }
                    else {
                        setReloadState(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: `솔루션 ${!isEnglish ? "" : "영문"}중그룹이 수정되었습니다.` }));
                        ClosePop("pop-e-2");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReloadState(false);
                    }
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    // 대표 이미지
    function DefaultImages(middleGroupId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            formData.append("file", defaultImg);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/image/energyconsulting/middlegroup?middleGroupId=${middleGroupId}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 중그룹이 수정되었습니다." }));
                    ClosePop("pop-e-2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                }
                else {
                    setReloadState(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 중그룹은 수정은 됐으나, 이미지 등록을 실패했습니다." }));
                    ClosePop("pop-e-2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadState(false);
                }
            }
        });
    }
    // 첨부파일
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function DefaultFileImage(e) {
        const file = e.target.files[0];
        setDefaultImg(file);
        e.target.value = "";
    }
    // 이미지 삭제
    function DeleteFile(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${defaultImg.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setDefaultImg(null);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "대표 이미지가 삭제되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(middleGroupEdit.name);
        setDescription(middleGroupEdit.description);
        setDefaultImg(middleGroupEdit.defaultImg);
        setFile([]);
        setPopreset(true);
        setIsEnglish(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: middleGroupEdit ? "" : "텍스트를 입력하세요", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: middleGroupEdit ? "" : "텍스트를 입력하세요", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB300\uD45C \uC774\uBBF8\uC9C0" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uD074\uB9AD\uD558\uC5EC \uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ onClick: (e) => handleFileUpload(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file3", ref: fileRef, accept: "image/*", onChange: (e) => DefaultFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "500MB\uC774\uD558\uC758 JPG, PNG\uD30C\uC77C 1\uAC1C\uB9CC \uC5C5\uB85C\uB4DC \uAC00\uB2A5\uD569\uB2C8\uB2E4." })), _jsx("ul", Object.assign({ className: "filelist" }, { children: defaultImg && (_jsxs("li", { children: [_jsx("span", { children: defaultImg.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => DeleteFile(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) }))] }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-e-2") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => MiddleGropEdit(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function MiddleGroupDeletePop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadState = useSetRecoilState(reLoadState);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { middleGroup, setMiddleGroup } = props;
    // state
    const [errorList, setErrorList] = useState([]);
    function MiddleGroupDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/energyconsulting/middlegroup/${middleGroup.id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: middleGroup,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setReloadPage(true);
                    setMiddleGroup(null);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "중그룹이 삭제 되었습니다." }));
                    CUTIL.jsclose_Popup("pop-d-2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                    setReloadState(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 카드에 등록되어 있는 그룹입니다." }));
                    CUTIL.jsclose_Popup("pop-d-2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC194\uB8E8\uC158\uC758 \uC911\uADF8\uB8F9\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-d-2") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            MiddleGroupDelete(e);
                        } }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
function SmallGroupAddPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { middleGroup, setPopreset, isEnglish, setIsEnglish, smallGroupEdit } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    function SmallGropAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setName(null);
            setDescription(null);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyconsulting/smallgroup?middleGroupId=${middleGroup.id}`,
                appQuery: {
                    name: name,
                    description: description,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPage(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 소그룹이 등록되었습니다." }));
                    ClosePop("pop-a-3");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function SmallGropEnglish(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/smallgroup/${smallGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPage(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: "소그룹 영문솔루션이 등록 되었습니다." }));
                    ClosePop("pop-a-3");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(null);
        setDescription(null);
        setPopreset(true);
        setIsEnglish(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-a-3") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), isEnglish ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => SmallGropEnglish(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => SmallGropAdd(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) })))] }))] }));
}
function SmallGroupEditPop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { smallGroupEdit, setPopreset, isEnglish, setIsEnglish } = props;
    // state
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (smallGroupEdit) {
            DeliveryDataPopitem(smallGroupEdit.id, isEnglish);
        }
    }, [smallGroupEdit && smallGroupEdit.id, smallGroupEdit, isEnglish]);
    function DeliveryDataPopitem(id, isEnglish) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/smallgroup/${id}`,
                appQuery: {
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setName(data.body.name);
                    setDescription(data.body.description);
                }
            }
        });
    }
    function SmallGropEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyconsulting/smallgroup/${smallGroupEdit.id}`,
                appQuery: {
                    name: name,
                    description: description,
                    langId: !isEnglish ? 1 : 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPage(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: `소그룹 ${!isEnglish ? "" : "영문"}솔루션이 수정 되었습니다.` }));
                    ClosePop("pop-e-3");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setName(smallGroupEdit.name);
        setDescription(smallGroupEdit.description);
        setPopreset(true);
        setIsEnglish(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uADF8\uB8F9 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "name").length > 0 ? " input-error" : ""}`, type: "text", placeholder: smallGroupEdit ? "" : "텍스트를 입력하세요", value: name || "", onChange: (e) => setName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB0B4\uC6A9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h170", placeholder: smallGroupEdit ? "" : "텍스트를 입력하세요", value: description || "", onChange: (e) => setDescription(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ClosePop("pop-e-3") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SmallGropEdit(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function SmallGroupDeletePop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadPage = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { smallGroupEdit, setSmallGroupEdit } = props;
    // state
    const [errorList, setErrorList] = useState([]);
    function SmallGroupDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/energyconsulting/smallgroup/${smallGroupEdit.id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: smallGroupEdit,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPage(true);
                    setSmallGroupEdit(null);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "소그룹이 삭제 되었습니다." }));
                    CUTIL.jsclose_Popup("pop-d-3");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPage(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "솔루션 카드에 등록되어 있는 그룹입니다." }));
                    CUTIL.jsclose_Popup("pop-d-3");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC194\uB8E8\uC158\uC758 \uC18C\uADF8\uB8F9\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-d-3") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            SmallGroupDelete(e);
                        } }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
